<template>
  <div class="securityparameter-list">

    <v-container grid-list-xl fluid>
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-md-and-down">
              <h2><v-icon large class="mr-2">mdi-account-cog</v-icon>{{$t('administration.securityparameter.securityparameters')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div>
          </div>
        </v-toolbar>

          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <SecurityParameterFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.comment" slot-scope="{ item }">
            {{ $t('administration.securityparameter.' + item['name']) }}
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>

      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import SecurityParameterFilterForm from '../../components/securityparameter/Filter';
import DataFilter from '../../components/DataFilter';

export default {
  name: 'SecurityParameterList',
  servicePrefix: 'SecurityParameter',
  mixins: [ListMixin],
  components: {
    ActionCell,
    SecurityParameterFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('administration.securityparameter.parameter'), value: 'name' },
        { text: this.$t('administration.securityparameter.comment'), value: 'comment' },
        { text: this.$t('administration.securityparameter.value'), value: 'value' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('securityparameter', {
      items: 'list'
    }),
    ...mapFields('securityparameter', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('securityparameter', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
